module.exports = __webpack_public_path__ + "img/RecoveryCountText@3x.ea80fd93.png";